"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ResponsiveModal = _interopRequireDefault(require("../ResponsiveModal"));
var _PreviewCigarette = _interopRequireDefault(require("../Cigarette/components/PreviewCigarette"));
var _components = require("./components");
var styles = {
  root: {
    zIndex: 10000
  },
  overlay: {
    backgroundColor: '#0000008c'
  },
  modal: {
    margin: 0,
    padding: 0,
    verticalAlign: 'top',
    maxWidth: '100%',
    minWidth: '100%',
    overflow: 'visible'
  }
};
var SearchWidgetPreview = function SearchWidgetPreview(_ref) {
  var destinationName = _ref.destinationName,
    startDate = _ref.startDate,
    endDate = _ref.endDate,
    personsCount = _ref.personsCount,
    _ref$isMobile = _ref.isMobile,
    isMobile = _ref$isMobile === void 0 ? false : _ref$isMobile,
    _ref$isWhiteLabel = _ref.isWhiteLabel,
    isWhiteLabel = _ref$isWhiteLabel === void 0 ? false : _ref$isWhiteLabel,
    className = _ref.className,
    showPopup = _ref.showPopup,
    onOpenModal = _ref.onOpenModal,
    onCloseModal = _ref.onCloseModal,
    PopupComponent = _ref.PopupComponent,
    searchType = _ref.searchType,
    availableSearchTypes = _ref.availableSearchTypes;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(PreviewContainer, null, /*#__PURE__*/_react["default"].createElement(_components.SearchTabsPreview, {
    searchType: searchType,
    availableSearchTypes: availableSearchTypes,
    onClick: onOpenModal,
    isWhiteLabel: isWhiteLabel
  }), /*#__PURE__*/_react["default"].createElement(_PreviewCigarette["default"], {
    startDate: startDate,
    endDate: endDate,
    destinationName: destinationName,
    personsCount: personsCount,
    onClick: onOpenModal,
    isMobile: isMobile,
    className: className,
    searchType: searchType
  })), /*#__PURE__*/_react["default"].createElement(_ResponsiveModal["default"], {
    styles: styles,
    open: showPopup,
    showCloseIcon: false,
    onClose: onCloseModal,
    animationDuration: 1
  }, PopupComponent));
};
var PreviewContainer = _styledComponents["default"].div.withConfig({
  displayName: "SearchWidgetPreview__PreviewContainer",
  componentId: "sc-13xlrgo-0"
})(["width:100%;"]);
var _default = exports["default"] = SearchWidgetPreview;